import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import VerifiedInfo from '../VerifiedInfo';
import Avatar from '../Avatar';
import Link from '../Link';
import DropZone from './DropZone';
import Loader from '../Loader/Loader';

import { unreadThreadsQuery } from '../../lib/graphql';
import { doRemoveProfilePicture } from '../../actions/manageUserProfilePicture';
import messages from '../../locale/jsonMessages';
import { withQuery } from '../../hoc/withGraphql';
import { user_Account } from '../../lib/graphql/user';

import arrow from '/public/siteImages/rightSideArrow.svg';
import userIcon from '/public/siteImages/user.svg';
import starIcon from '/public/SiteIcons/outerStar.svg';

import { EditProfileIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cs from '../../components/commonStyle.css';
import s from './Dashboard.css';

const Dashboard = (props) => {
    const {
        account,
        data,
        doRemoveProfilePicture,
        profilePictureData: { userAccount },
        allUnreadThreads: { loading, getUnreadThreads },
        isDashboardPage,
        isEditProfilePage,
        isTrustVerfiedPage,
        profilePhotoLoading,
        isUser,
        isViewProfilePage
    } = props;

    const { formatMessage } = useIntl();
    const showProfile = isViewProfilePage && !isUser ? false : true;
    let userId = account?.userId, profileId = account?.profileId, picture = account?.picture;
    const isVerified = profileId;

    return (
        <>
            <div className={cx(s.avatarSectionBorder, cs.spaceBottom3, 'whiteBgColor')}>
                <div className={cx(s.avatarSection, cs.textAlignCenter)}>
                    <Loader
                        show={profilePhotoLoading}
                        type={"page"}
                    >
                        <Avatar
                            height={150}
                            width={150}
                            className={cs.profileAvatarLink}
                            source={data && data.picture}
                            isUser={showProfile}
                        />
                        {showProfile && userAccount?.picture && <DropZone
                            guestPicture={picture}
                            isEditIcon={true}
                        />}
                    </Loader>

                    {showProfile && !userAccount?.picture && <DropZone
                        guestPicture={picture}
                        defaultMessage={formatMessage(messages.updatePhotoLabel)}
                        isEditIcon={false}
                    />}
                </div>
                {showProfile && userAccount?.picture && <div className={cx(cs.textAlignCenter, cs.spaceTop3, cs.spaceBottom11)}><Link onClick={() => doRemoveProfilePicture(userAccount?.picture)}
                    className={cx(cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor, cs.textDecorationNone, cs.commonLinkBorderBottom, cs.textAlignCenter, cs.curserPointer)}>
                    <FormattedMessage {...messages.removeProfilePhoto} /></Link></div>}
                <hr className={cx(cs.listingHorizoltalLine, cs.spaceTop3, cs.spaceBottom3)} />
                <VerifiedInfo userId={showProfile ? userId : data && data.userId} isTrustVerfiedPage={isTrustVerfiedPage} isUser={showProfile} />
            </div>
            {!isDashboardPage && showProfile && <Link to={'/user/reviews/about-you'} className={cx(cs.commonContentText, cs.fontWeightMedium, cs.siteTextColor, cs.textDecorationNone, s.btnDisplayGrid, s.viewProfileGrid, cs.spaceBottom3, 'whiteBgColor')}>
                <img src={starIcon} />
                <div className={s.btnDisplayFlex}>
                    <h4 className={cx(cs.commonMediumText, cs.fontWeightNormal)}><FormattedMessage {...messages.reviews} /></h4>
                    <img src={arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                </div>
            </Link>
            }

            {!isEditProfilePage && showProfile && <Link to={'/user/edit'} className={cx(cs.commonContentText, cs.fontWeightMedium, cs.siteTextColor, cs.textDecorationNone, s.btnDisplayGrid, s.viewProfileGrid, cs.spaceBottom3, 'whiteBgColor')}>
                <EditProfileIcon className={'commonLinkColor'}/>
                <div className={s.btnDisplayFlex}>
                    <h4 className={cx(cs.commonMediumText, cs.fontWeightNormal)}><FormattedMessage {...messages.editProfile} /></h4>
                    <img src={arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                </div>
            </Link>
            }

            {isEditProfilePage && showProfile && <Link to={'/users/show/' + isVerified} className={cx(cs.commonContentText, cs.fontWeightMedium, cs.siteTextColor, cs.textDecorationNone, s.btnDisplayGrid, s.viewProfileGrid, 'whiteBgColor')}>
                <img src={userIcon} />
                <div className={s.btnDisplayFlex}>
                    <h4 className={cx(cs.commonMediumText, cs.fontWeightNormal)}><FormattedMessage {...messages.viewProfile} /></h4>
                    <img src={arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                </div>
            </Link>
            }
        </>
    );
};

Dashboard.propTypes = {
    account: PropTypes.shape({
        userId: PropTypes.string.isRequired,
        picture: PropTypes.string,
    }).isRequired,
    allUnreadThreads: PropTypes.shape({
        loading: PropTypes.bool.isRequired,
        getUnreadThreads: PropTypes.array
    }),
    siteName: PropTypes.string.isRequired,
    isDashboardPage: PropTypes.bool,
    isEditProfilePage: PropTypes.bool,
    isTrustVerfiedPage: PropTypes.bool
};

Dashboard.defaultProps = {
    allUnreadThreads: {
        loading: true,
        getUnreadThreads: []
    },
    account: {
        userId: null,
        picture: null
    }
};

const mapState = (state) => ({
    account: state.account.data,
    siteName: state.siteSettings.data.siteName,
    userData: state.account.data,
    profilePhotoLoading: state.account.profilePhotoLoading
});

const mapDispatch = {
    doRemoveProfilePicture
};

export default compose(
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withQuery(user_Account, {
        name: 'profilePictureData',
        options: {
            ssr: false,
            fetchPolicy: 'network-only'
        }
    }, unreadThreadsQuery, {
        name: 'allUnreadThreads',
        options: {
            ssr: false,
            fetchPolicy: 'network-only'
        }
    }
    )
)(Dashboard);